(function () {
    'use strict';

    angular
        .module('app')
        .controller('CriticalPathDevPrototypeEditController', criticalPathDevPrototypeEditController);

    function criticalPathDevPrototypeEditController($scope, $window, $rootScope, $filter, $timeout, $state, $stateParams, $q, ImageUrl, UserService, LinePlanService, PrototypeService, CriticalPathService, PatternService, ReportService, DefaultThumbnailSize, DefaultEnlargeSize, UserPreferenceService, toaster, cfpLoadingBar, QUtil) {
        var model = this;
        $scope.devPrototypeId = $stateParams.devPrototypeId;
        $scope.isFactoryUser = $rootScope.isFactoryUser;
        $scope.userId = $rootScope.userId;
        $scope.brandPermissions = $rootScope.brandPermissions;
        $scope.linkPsid = $stateParams.psid;
        $scope.criticalPathCommercializationId = $stateParams.criticalPathCommercializationId;
        $scope.CanViewFactoryFields = $rootScope.globals.currentUser.isFactoryUser !== true;
        $scope.currentUser = $rootScope.globals.currentUser;
        $scope.fullName = $rootScope.fullName;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        model.CriticalPathDevPrototypeRead = false;
        model.CriticalPathDevPrototypeEdit = false;
        model.ECNPermission = false;
        model.CanViewFactoryFields = $rootScope.globals.currentUser.isFactoryUser !== true;

        $scope.poNotesCarryover1 = 'poNotesCarryover1.html';
        $scope.poNotesCarryover2 = 'poNotesCarryover2.html';
        $scope.poNotesCarryover3 = 'poNotesCarryover3.html';
        $scope.poNotes = 'poNotes.html';

        model.ReadOnly_LTHAPP = false;
        model.ReadOnly_FNLCSTCONF = false;
        model.ReadOnly_31MTLCOTST = false;
        model.ReadOnly_PATAPP = false;
        model.ReadOnly_SAMPAPP = false;
        model.ReadOnly_MTLFLDSGND = false;
        model.ReadOnly_PRJHISTCMPL = false;
        model.CanEditName = false;

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] === 12) {
                if (userPermissionRow[1] === 1) {
                    model.CriticalPathDevPrototypeRead = true;
                }
                if (userPermissionRow[1] === 2) {
                    model.CriticalPathDevPrototypeEdit = true;
                }
            }

            //check ECN permission
            if (userPermissionRow[0] === 5) {
                if (userPermissionRow[1] === 8) {
                    model.ECNPermission = true;
                }
            }

        });

        //If user doesnt have Read or Edit, redirect to Permission Denied Page
        if (model.CriticalPathDevPrototypeRead === false && model.CriticalPathDevPrototypeEdit === false) {
            $state.go('permissionDenied');
        }

        model.isReadOnly = true;

        if (model.CriticalPathDevPrototypeRead === true && model.CriticalPathDevPrototypeEdit === false) {
            model.isReadOnly = true;
        }

        if (model.CriticalPathDevPrototypeEdit === true) {
            model.isReadOnly = false;
        }

        model.devPrototypeId = $stateParams.devPrototypeId;

        if ($stateParams.psid)
            model.linkPsid = $stateParams.psid;

        if (!model.devPrototypeId) {
            $state.go('home');
        }

        model.ImageUrl = ImageUrl;
        model.criticalPathDevPrototypeHeaderDetails = "";
        model.cpDevPrototypeActualProcessesData = [];
        model.cpDevPrototypeActualProcessesToDelete = [];
        model.cpDevPrototypeFinalProcessesData = [];
        model.cpDevPrototypeFinalProcessesToDelete = [];
        model.prototypeStockNumbersData = [];
        model.stockNumbersData = [];

        model.init = function () {

            QUtil.whenAll([model.getDevPrototypeWithProcesses]).then(function () {
                model.getOtherSeasons();
                model.getCommercializations();
                model.getDevPatterns();
                model.getLinePlanLaunchDateDetails();
                model.getDevelopers();
            });

            CriticalPathService.getCriticalPathHeaderStatusList().then(function (statusData) {
                model.criticalPathHeaderStatusList = statusData;
            });

            CriticalPathService.getCriticalPathProcessApprovedList().then(function (processApprovedData) {
                model.criticalPathProcessApprovedList = processApprovedData;
            });
        }

        //start headerminimized options for cp
        //UserPreferenceService.getUserPreferences('HeaderMinimized').then(function (response) {
        //    model.headerMinimized = false;
        //    if (response && response.length > 0) {
        //        var userReportModel = eval('(' + response[0].PreferenceValue + ')');
        //        model.headerMinimized = userReportModel.minimized;
        //        model.userPreferenceId = response[0].UserPreferenceId;
        //    }
        //});

        model.minimizeToggle = function () {
            if (model.headerMinimized) {
                model.headerMinimized = false;
            } else {
                model.headerMinimized = true;
            }
            //user preference for minimized
            var userPreferenceModel = {
                UserPreferenceId: model.userPreferenceId,
                PreferenceName: "HeaderMinimized",
                model: angular.toJson({ "minimized": model.headerMinimized }),
                EnsureUnique: true
            };

            UserPreferenceService.updateUserPreferences(userPreferenceModel).then(function (response) {
                if (response !== 1) {
                    //change user preference id only when a new one is added
                    model.userPreferenceId = response;
                }
            });
        };

        function getFactoryPermissions(factoryKey) {
            if (!$rootScope.isFactoryUser) {
                return;
            }
            UserService.getUserFactories($rootScope.userId).then(function (response) {
                if (!response) {
                    return;
                }
                var idx = response.map(function (e) { return e.FactNameKy }).indexOf(factoryKey);
                if (idx < 0) { //no fatcory record for this user at all
                    $state.go('permissionDenied');
                    return;
                }
                if (!response[idx].IsAssigned) { //for some reason there is a record but the factory is unassigned...
                    $state.go('permissionDenied');
                    return;
                }
            });
        };

        function getBrandPermissions(brandId) {
            //brand permissions
            if (!$rootScope.brandPermissions)
                return;
            var idx = $rootScope.brandPermissions.map(function (e) { return e.BrandId }).indexOf(brandId);
            if (!$rootScope.brandPermissions[idx].IsAssigned) {
                $state.go('permissionDenied');
                return;
            }
        };

        model.getDevPrototypeWithProcesses = function () {

            model.cpDevPrototypeActualProcessesData = [];
            model.cpDevPrototypeActualProcessesToDelete = [];
            model.cpDevPrototypeFinalProcessesData = [];
            model.cpDevPrototypeFinalProcessesToDelete = [];

            var deferred = $q.defer();

            CriticalPathService.getDevPrototypeWithProcesses(model.devPrototypeId).then(function (response) {
                if (!response) {
                    $state.go('permissionDenied');
                    return;
                }

                model.devPrototype = response;

                model.hasFactory = model.devPrototype.FactoryKey !== null && model.devPrototype.FactoryKey.length > 0;

                //As is this will never be useful. the getDevPrototypeWithProcesses filters by factory for factory users and will return null if
                //a factory user is not assigned the factory for the CP.  So the above check on !response will cause the state.go to occur.
                //But might as well leave this here in case that logic changes, and this exact function works create on criticalpathcommercializationedit.ctrl.js
                getFactoryPermissions(model.devPrototype.FactoryKey);

                getBrandPermissions(model.devPrototype.BrandId);

                model.criticalPathDevPrototypeActualProcesses = model.devPrototype.ActualProcesses;

                model.prototypeImage = ImageUrl + "?projectId=" + model.devPrototype.PrototypeId + "&projectLevel=4&imageType=1&size=" + DefaultThumbnailSize;
                model.prototypeImageFull = ImageUrl + "?projectId=" + model.devPrototype.PrototypeId + "&projectLevel=4&imageType=1&size=" + DefaultEnlargeSize;

                if (!model.linkPsid)
                    model.linkPsid = model.devPrototype.PrototypeSeasonalId;

                model.criticalPathDevPrototypeFinalProcesses = model.devPrototype.FinalProcesses;

                angular.forEach(model.criticalPathDevPrototypeFinalProcesses,
                    function (k) {
                        k.EstStartDate = $filter('date')(k.EstStartDate, "MM/dd/yyyy");
                        if (k.EstStartDate) {
                            k.CanEditEstStartDate = false;
                        }
                        k.TargetDate = $filter('date')(k.TargetDate, "MM/dd/yyyy");
                        if (k.TargetDate && k.TargetDate !== null) {
                            k.CanEditTargetDate = false;
                        }
                        k.RevStartDate = $filter('date')(k.RevStartDate, "MM/dd/yyyy");
                        k.RevisedTargetDate = $filter('date')(k.RevisedTargetDate, "MM/dd/yyyy");
                        k.ActualCompleteDate = $filter('date')(k.ActualCompleteDate, "MM/dd/yyyy");
                        k.ApprovalDate = $filter('date')(k.ApprovalDate, "MM/dd/yyyy");

                    });

                model.loadingStockNumbers = true;
                CriticalPathService.getStockNumberModels(model.devPrototypeId).then(function (stockNumberModels) {
                    model.stockNumbersData = stockNumberModels;

                    model.loadingStockNumbers = false;
                });

                angular.forEach(model.criticalPathDevPrototypeActualProcesses, function (k) {
                    k.ActualCompleteDate = $filter('date')(k.ActualCompleteDate, "MM/dd/yyyy");
                });

                PrototypeService.getPrototypeSeasonalDetails(model.linkPsid).then(function (prototypeSeasonal) {

                    UserService.getUsersByBrand(prototypeSeasonal.BrandId).then(function (data) {
                        model.users = data;
                    });

                    CriticalPathService.getPrototypePurchaseOrders(model.linkPsid).then(function (purchaseOrdersResponse) {
                        model.purchaseOrdersData = purchaseOrdersResponse;
                    });
                });

                deferred.resolve();
            });

            return deferred.promise;
        }

        model.getDevelopers = function () {
            PatternService.getAllDevelopersList(model.devPrototype.BrandId, true).then(function (data) {
                model.designerList = PatternService.filterDevelopersByRole(data, 1, model.devPrototype.Designer, true);
                model.developerList = PatternService.filterDevelopersByRole(data, 2, model.devPrototype.USDeveloper, true);
                model.sourcingDeveloperList = PatternService.filterDevelopersByRole(data, 3, model.devPrototype.AsiaDeveloper, true);
            });
        }

        model.getCommercializations = function () {
            CriticalPathService.getCpCommercializationsForPrototype(model.devPrototype.PrototypeSeasonalId).then(function (cpDevProtoCommercializationsResponse) {
                model.cpDevProtoCommercializations = cpDevProtoCommercializationsResponse;
            });
        }

        model.getDevPatterns = function () {
            CriticalPathService.getDevPatternsForDevPrototype(model.devPrototype.CriticalPathDevPrototypeId).then(function (cpPatterns) {
                model.patternCriticalPaths = cpPatterns;
            });
        }

        model.getLinePlanLaunchDateDetails = function () {
            if (model.devPrototype.LinePlanLaunchDateId) {
                LinePlanService.getLinePlanLaunchDateDetails(model.devPrototype.LinePlanLaunchDateId).then(function (linePlanLaunchDateResponse) {
                    model.linePlanLaunchDateDetails = linePlanLaunchDateResponse;
                });
            }
            else {
                model.linePlanLaunchDateDetails = "";
            }
        }

        model.getOtherSeasons = function () {
            var searchObject = {
                CriticalPathDevPrototypeId: model.devPrototype.CriticalPathDevPrototypeId,
                PageNumber: 1,
                PageSize: 999,
                SortColumn: "SeasonSequence"
            }
            return PrototypeService.searchPrototypes(searchObject).then(function (response) {
                model.otherSeasons = _.filter(response.results, function (p) { return p.PrototypeSeasonalId !== model.devPrototype.PrototypeSeasonalId });
            });
        };

        model.closeModal = function () {
            $('#seasonList').modal('hide');
        };

        model.daysRemainingActual = function (process) {
            return model.daysRemaining(process, process.ActualCompleteDate);
        };

        model.daysRemainingFinal = function (process) {
            return model.daysRemaining(process, process.ApprovalDate);
        };

        model.daysRemaining = function (process, completeDate) {
            if (process.TargetDate === null) return null;
            if (completeDate === null) return null;

            var targetDateMoment = moment(process.TargetDate).startOf("day");
            var completeDateMoment = moment(completeDate).startOf("day");

            process.DaysRemaining = targetDateMoment.diff(completeDateMoment, "days");
            return process.DaysRemaining;
        }

        model.canDevProtoCriticalPathBeCanceled = function () {
            $scope.criticalPathDevPrototypeEditForm.$setValidity('criticalPathCannotBeCanceled', true);

            if (model.devPrototype.CriticalPathHeaderStatusId === 1) {
                CriticalPathService.canDevProtoCriticalPathBeCanceled(model.devPrototype.CriticalPathDevPrototypeId)
                    .then(function (response) {

                        if (response === false) {
                            $scope.criticalPathDevPrototypeEditForm.$setValidity('criticalPathCannotBeCanceled', false);
                        }
                    });
            }
        }

        model.getUser = function (scope, item) {
            //required because sometimes its an object with properties or a string
            var fullName = item.ApprovedByName ? (!item.ApprovedByName.length ? item.ApprovedByName.FullName.trim() : item.ApprovedByName.trim()) : "";
            if (fullName !== "") {
                UserService.getUserByNameandBrand(model.devPrototype.BrandId, fullName)
                    .then(function (response) {
                        if (response.Id !== 0) {
                            item.ApprovedBy = response.Id;
                            scope.criticalPathDevProtoFinalProcessesForm.accountable.$setValidity('accountableName', true);
                        }
                        else {
                            scope.criticalPathDevProtoFinalProcessesForm.accountable.$setValidity('accountableName', false);
                        }
                    },
                        function () {
                            scope.criticalPathDevProtoFinalProcessesForm.accountable.$setValidity('accountableName', false);
                        });
            } else {
                item.ApprovedBy = '';
            }
        };

        $scope.tableBlur = function (n, o, arr, event) {
            if (arr[o].SortOrder !== arr[o].SortOriginal) {
                event.preventDefault();
                $scope.tableOrder(n, o, arr, event);
            }
        }

        $scope.tableOrder = function (n, o, arr, event, ri) {
            var compareId;
            //if this isnt a re-index, dont run this code
            if (!ri) {
                //check the o.r., you like it so far?
                var oArr = arr;
                if (oArr === 'sortableTable1') {
                    arr = model.criticalPathDevPrototypeActualProcesses;
                    compareId = 'CriticalPathDevPrototypeActualProcessId';
                }

                if (oArr === 'sortableTable2') {
                    arr = model.criticalPathDevPrototypeFinalProcesses;
                    compareId = 'CriticalPathDevPrototypeFinalProcessId';
                }

                //sort the model - only necessary on blur
                var dm = false;
                if (n === true) {
                    dm = arr[o][compareId];
                    arr.sort(function (a, b) {
                        return a.SortOrder - b.SortOrder;
                    });
                } else {
                    //dont do it if there is no old index
                    if (o !== false) {
                        //actually moving the index...
                        var obj = arr[o];
                        arr.splice(o, 1);
                        arr.splice(n, 0, obj);
                    }
                }
            };

            //reindex
            var i = 0;
            angular.forEach(arr, function (k) {
                if (dm) {
                    dm === k[compareId] ? n = i : '';
                };
                i++;
                k.SortOrder = i * 10;
                k.SortOriginal = i * 10;
            });

            //update model
            $scope.$evalAsync(function () {
                $timeout(function () {
                    model.setIndexId(n);
                    if (typeof $scope.focusElement !== 'undefined') {
                        $scope.focusElement.querySelectorAll('.focusInput')[0].focus();
                    }
                });
            });
        };

        $scope.startSortable = function (table) {
            var sortableTable = document.getElementById(table);
            Sortable.create(sortableTable, {
                handle: '.draggable',
                animation: 150,
                onEnd: function (evt) {
                    $scope.focusElement = undefined;
                    $scope.tableOrder(evt.newIndex, evt.oldIndex, evt.from.id);
                }
            });
        }

        $scope.tableOrderKey = function (event, $index, array) {
            //backspace, tab, up, down, left, right arrows, enter
            var allowedKeys = [8, 9, 13, 37, 38, 39, 40, 46, 116];
            var allowedMetaKeys = [65, 86, 67, 88, 82, 90];
            //Ctrl, Ctrl + A, Ctrl + C, Ctrl + V, Ctrl + X, Ctrl + R, Ctrl + Z
            var eventKey = event.key;

            //no spacebar
            if (eventKey === " ") {
                eventKey = 'x';
                //just defaulting it to a value that isnt allowed
            }

            if (isNaN(eventKey) && eventKey !== 'Tab') {
                //if ctrl isnt being pressed
                var ctrlMeta = event.ctrlKey === true || event.metaKey === true;
                if (ctrlMeta) {
                    //move to first
                    if (event.keyCode === 38) {
                        $scope.tableOrder(0, $index, array, null);
                        $scope.focusElement = event.path[3].children[0];
                    }
                    //move to last
                    if (event.keyCode === 40) {
                        $scope.tableOrder(array.length - 1, $index, array, null);
                        $scope.focusElement = event.path[3].children[array.length - 1];
                    }
                } else {
                    if (allowedKeys.indexOf(event.keyCode) === -1) {
                        event.preventDefault();
                    }
                    if (allowedMetaKeys.indexOf(event.keyCode) > -1) {
                        event.preventDefault();
                    }

                    //move up 1
                    if (event.keyCode === 38) {
                        if ($index !== 0) {
                            $scope.tableOrder($index - 1, $index, array, null);
                            $scope.focusElement = event.path[3].children[$index - 1];
                        }
                    }

                    //move down 1
                    if (event.keyCode === 40) {
                        if ($index !== array.length - 1) {
                            $scope.tableOrder($index + 1, $index, array, null);
                            $scope.focusElement = event.path[3].children[$index + 1];
                        }
                    }
                }
            }
        };

        //default sort order set to false (desc) so when you first click, its asc
        $scope.tableSortDir = '';
        $scope.tableSort = function (h) {
            if (h !== $scope.tableSortName) {
                //reset order direction if new name is chosen
                $scope.tableSortDir = '';
            }

            $scope.tableSortName = h;

            if ($scope.tableSortDir === '') { //first click
                $scope.tableSortDir = false;
                $scope.tableSortClass = 'fa-caret-up';
            } else if ($scope.tableSortDir === false) { //second click
                $scope.tableSortDir = true;
                $scope.tableSortClass = 'fa-caret-down';
            } else { //third click, reset it all
                $scope.tableSortDir = '';
                $scope.tableSortClass = '';
                $scope.tableSortName = '';
            }
        };

        //Set Selected Row
        model.setIndexId = function (currentIndex) {
            model.indexId = currentIndex;
        }

        model.addRow = function (idx, arr, a, t) {
            $scope.criticalPathDevPrototypeEditForm.$setDirty();

            var item = {
                CriticalPathDevPatternProcessId: 0,
                Name: "",
                TargetDate: "",
                ActualCompleteDate: "",
                ProcessType: "DEF",
                Notes: null,
                Notes2: null,
                CanChangeName: true,
                CanBeDeleted: true,
                CanEditActualCompleteDate: true,
                CanEditEstStartDate: true,
                CanEditTargetDate: true,
                CanEditRevisedTargetDate: true,
                CanEditRevStartDate: true,
                CanEditStatus: true
            };

            arr.splice(idx + a, 0, item);

            var e = document.getElementById(t);
            $scope.focusElement = e.children[idx + a];
            $scope.tableOrder(idx + a, false, arr, true);
        }

        //Delete row
        model.deleteRowActualProcesses = function (currentIndex) {
            $scope.criticalPathDevPrototypeEditForm.$setDirty();
            if ($window.confirm("This action will delete the current row. Do you want to continue?")) {
                //mark row to delete from database only if process exists
                if (model.criticalPathDevPrototypeActualProcesses[currentIndex].CriticalPathDevPrototypeActualProcessId !== 0) {
                    model.cpDevPrototypeActualProcessesToDelete.push({ CriticalPathDevPrototypeActualProcessId: model.criticalPathDevPrototypeActualProcesses[currentIndex].CriticalPathDevPrototypeActualProcessId });
                }
                model.criticalPathDevPrototypeActualProcesses.splice(currentIndex, 1);

            }
        };

        //Set Selected Row
        model.setActualProcessesIndexId = function (currentIndex) {
            model.actualProcessIndexId = currentIndex;
        };

        //get Prototype Line Plan dates
        model.getLinePlanDates = function (scope, currentIndex) {
            if (model.criticalPathDevPrototypeActualProcesses[currentIndex].ProcessName) {
                CriticalPathService.getCriticalPathPrototypeLinePlanProcessDates(model.devPrototype.CriticalPathDevPrototypeId, model.criticalPathDevPrototypeActualProcesses[currentIndex].ProcessName)
                    .then(function (response) {
                        if (response) {
                            model.criticalPathDevPrototypeActualProcesses[currentIndex].TargetDate = response.EndDate;
                        }
                    });
            }
        };

        //Final Processes Add and Delete Rows functions
        //Add Row above Current row
        model.addRowAboveCurrentFinalProcesses = function (currentIndex) {

            $scope.criticalPathDevPrototypeEditForm.$setDirty();

            var item = { CriticalPathDevPrototypeFinalProcessId: 0, Name: "", EstStartDate: "", TargetDate: "", RevStartDate: "", RevisedTargetDate: "", ActualCompleteDate: "", Notes: "", Notes2: null, CanChangeName: true, CanBeDeleted: true, IsProcessLocked: false };
            model.criticalPathDevPrototypeFinalProcesses.splice(currentIndex, 0, item);
        };

        //Add Row above Current row
        model.addRowBelowCurrentFinalProcesses = function (currentIndex) {

            $scope.criticalPathDevPrototypeEditForm.$setDirty();

            var item = { CriticalPathDevPrototypeFinalProcessId: 0, Name: "", TargetDate: "", RevisedTargetDate: "", Notes: "", Notes2: null, CanChangeName: true, CanBeDeleted: true, IsProcessLocked: false };
            model.criticalPathDevPrototypeFinalProcesses.splice(currentIndex + 1, 0, item);
        }

        //Add Row above Current row
        model.addRowFinalProcesses = function (idx, arr, a) {

            $scope.criticalPathDevPrototypeEditForm.$setDirty();

            var item = { CriticalPathDevPrototypeFinalProcessId: 0, Name: "", EstStartDate: "", TargetDate: "", RevStartDate: "", RevisedTargetDate: "", ActualCompleteDate: "", Notes: "", Notes2: null, CanChangeName: true, CanBeDeleted: true, IsProcessLocked: false };
            arr.splice(currentIndex + a, 0, item);
        };

        //Delete row
        model.deleteRowFinalProcesses = function (currentIndex) {
            $scope.criticalPathDevPrototypeEditForm.$setDirty();
            if ($window.confirm("This action will delete the current row. Do you want to continue?")) {
                //mark row to delete from database only if process exists
                if (model.criticalPathDevPrototypeFinalProcesses[currentIndex].CriticalPathDevPrototypeFinalProcessId !== 0) {
                    model.cpDevPrototypeFinalProcessesToDelete.push({ CriticalPathDevPrototypeFinalProcessId: model.criticalPathDevPrototypeFinalProcesses[currentIndex].CriticalPathDevPrototypeFinalProcessId });
                }
                model.criticalPathDevPrototypeFinalProcesses.splice(currentIndex, 1);
            }
        };

        //Set Selected Row
        model.setFinalProcessesIndexId = function (currentIndex) {
            model.finalProcessIndexId = currentIndex;
        }

        model.IsFinalSpecFunc = function (e, i, idx) {
            model.specAppCurrentId = i.PrototypeSeasonalId;
            model.specAppCurrentIndex = idx;
            if (e) {
                i.tempCheck = true;
            }
        };

        var procUpdateType = [
            { ProcessType: 'SPECAPP', model: 'IsFinalSpecApprLocked' },
            { ProcessType: 'LTHAPP', model: 'IsLeatherApproved' },
            { ProcessType: 'FNLCSTCONF', model: 'IsFinalCostConfCBDLoaded' },
            { ProcessType: '31MTLCOTST', model: 'IsThreeOneTestComplete' },
            { ProcessType: 'SAMPAPP', model: 'IsConfirmationSampleApproved' },
            { ProcessType: 'MTLFLDSGND', model: 'IsMatlRefFolderSigned' },
            { ProcessType: 'PROP65LEAD', model: 'IsRSTestComplete' },
            { ProcessType: 'PATAPP', model: 'IsModelSizeApproved' },
            { ProcessType: 'CNFSMPSND', model: 'IsConfSampleSent' }
        ];

        model.stockNumberDetailsUpdate = function (e, tf, index) {
            if (index === model.devPrototype.PrototypeSeasonalId) {
                angular.forEach(model.criticalPathDevPrototypeFinalProcesses, function (key, v) {
                    if (key.ProcessType === e) {
                        if (tf) {
                            model.criticalPathDevPrototypeFinalProcesses[v].CriticalPathProcessApprovedId = 1;
                            model.setApprovalData(v, key.ProcessType, 1, true);
                        } else {
                            model.criticalPathDevPrototypeFinalProcesses[v].CriticalPathProcessApprovedId = 2;
                            model.setApprovalData(v, key.ProcessType, 2, true);
                        }
                    }
                });

                if (e === 'SPECAPP' && !tf) {
                    model.stockNumbersData[0]['IsFinalSpecApprLocked'] = true;
                    model.ifSpecAppPopup(0, e, 2, true);
                }
            }
        };

        //popup from check on stock number approvals
        model.ifSpecAppStockPopup = function (currentIndex, procType, approvalCode, $index) {
            if (procType === 'SPECAPP' && approvalCode) {
                model.stockNumbersData[currentIndex].tempCheck = true;
            }
            if (procType === 'SPECAPP' && !approvalCode && (model.tempSpecLock || model.stockNumbersData[currentIndex]['tempCheck'])) {
                model.stockNumbersData[currentIndex].IsFinalSpecApprLocked = true;
                model.specAppApprovalCode = 2;
                $('#specAppPopup').modal();
            } else {
                model.stockNumberDetailsUpdate(procType, approvalCode, $index);
            }
        };

        //popup from details (processes table)
        model.ifSpecAppPopup = function (currentIndex, procType, approvalCode, updateFromStock) {

            if (procType === "SPECAPP") {
                if (approvalCode === 1) {
                    model.tempSpecLock = true;
                }
                if ((approvalCode === null || approvalCode === 2) && (model.tempSpecLock || model.stockNumbersData[0]['tempCheck'])) {
                    model.criticalPathDevPrototypeFinalProcesses[currentIndex].CriticalPathProcessApprovedId = 1;
                    model.specAppApprovalCode = approvalCode;
                    $('#specAppPopup').modal();
                } else {
                    model.setApprovalData(currentIndex, procType, approvalCode, updateFromStock);
                }
            } else {
                if ((approvalCode === null || approvalCode === 2) && (model.tempSpecLock || model.stockNumbersData[0]['tempCheck']))
                    return;

                model.setApprovalData(currentIndex, procType, approvalCode, updateFromStock);
            }
        };

        model.ifSpecAppPopupYes = function () {
            //uncheck non linked stock #'s
            if (model.devPrototype.PrototypeSeasonalId !== model.specAppCurrentId) {
                model.stockNumbersData[model.specAppCurrentIndex].IsFinalSpecApprLocked = false;
                model.stockNumbersData[model.specAppCurrentIndex].IsLeatherApproved = false;
                model.stockNumbersData[model.specAppCurrentIndex].IsFinalCostConfCBDLoaded = false;
                model.stockNumbersData[model.specAppCurrentIndex].IsThreeOneTestComplete = false;
                model.stockNumbersData[model.specAppCurrentIndex].IsConfirmationSampleApproved = false;
                model.stockNumbersData[model.specAppCurrentIndex].IsMatlRefFolderSigned = false;
                model.stockNumbersData[model.specAppCurrentIndex].IsModelSizeApproved = false;
                model.stockNumbersData[model.specAppCurrentIndex].IsConfSampleSent = false;
            }

            angular.forEach(model.criticalPathDevPrototypeFinalProcesses, function (p, v) {
                if (p.ProcessType === "SPECAPP") {
                    model.criticalPathDevPrototypeFinalProcesses[v].CriticalPathProcessApprovedId = model.specAppApprovalCode;
                    model.setApprovalData(v, p.ProcessType, 2, false);
                } else if (p.ProcessType !== 'PROP65LEAD') {
                    model.criticalPathDevPrototypeFinalProcesses[v].CriticalPathProcessApprovedId = '';
                    model.setApprovalData(v, p.ProcessType, '', false);
                }
            });

            delete model.specAppApprovalCode;
        };

        model.setApprovalData = function (currentIndex, procType, approvalCode, updateFromStock) {
            if (procType === 'SPECAPP') {
                angular.forEach(model.criticalPathDevPrototypeFinalProcesses, function (k, v) {
                    var p = model.criticalPathDevPrototypeFinalProcesses[v];

                    if (p.IsProcessReadOnly === true)
                        return;

                    if (p.ProcessType === 'PROP65LEAD')
                        return;

                    if (approvalCode === 1) {
                        p.IsProcessLocked = false;

                    }
                    if (v > 0 && approvalCode !== 1) {
                        p.IsProcessLocked = true;
                    }
                });
            }

            if (model.criticalPathDevPrototypeFinalProcesses[currentIndex].CriticalPathProcessApprovedId > 0) {
                model.criticalPathDevPrototypeFinalProcesses[currentIndex].ApprovedByName = $rootScope.fullName;
                model.criticalPathDevPrototypeFinalProcesses[currentIndex].ApprovalDate = $filter('date')(new Date(), 'MM/dd/yyyy');
                model.criticalPathDevPrototypeFinalProcesses[currentIndex].ApprovedBy = $rootScope.userId;
            }
            else {
                model.criticalPathDevPrototypeFinalProcesses[currentIndex].ApprovedByName = "";
                model.criticalPathDevPrototypeFinalProcesses[currentIndex].ApprovalDate = "";
                model.criticalPathDevPrototypeFinalProcesses[currentIndex].ApprovedBy = "";
            }

            var idToUpdate = model.devPrototype.PrototypeSeasonalId;

            var objIndexToUpdate = "";
            angular.forEach(model.stockNumbersData, function (k, v) {
                if (k.PrototypeSeasonalId === idToUpdate) {
                    objIndexToUpdate = v;
                }
            });

            //change checkboxes on stock number approvals
            if (!updateFromStock && objIndexToUpdate !== "") {
                angular.forEach(procUpdateType, function (k) {
                    if (k.ProcessType === procType) {
                        //UPDATE 12/4 -- new business requirements state that the process is approved with "Yes", "Existing", and "N/A" selections,
                        //not just "Yes" selections; approvalCode 1, 4, and 5 are all equivalent to "approved"
                        if (approvalCode === 1 || approvalCode === 4 || approvalCode === 5) {
                            model.stockNumbersData[objIndexToUpdate][k.model] = true;
                            if (procType === 'SPECAPP')
                                model.IsFinalSpecFunc(true, model.stockNumbersData[objIndexToUpdate]);
                        } else {
                            model.stockNumbersData[objIndexToUpdate][k.model] = false;
                        }
                    }
                });
            }
        };

        //Save Prototype Header and Details
        model.Save = function (isFormInvalid) {
            if (!isFormInvalid) {
                $scope.criticalPathDevPrototypeEditForm.$setPristine();

                //Get Header Data
                model.criticalPathDevPrototypeData = {
                    CriticalPathDevPrototypeId: model.devPrototype.CriticalPathDevPrototypeId,
                    CriticalPathDevPrototypeName: model.devPrototype.CriticalPathDevPrototypeName,
                    Designer: model.devPrototype.Designer,
                    USDeveloper: model.devPrototype.USDeveloper,
                    AsiaDeveloper: model.devPrototype.AsiaDeveloper,
                    CriticalPathHeaderStatusId: model.devPrototype.CriticalPathHeaderStatusId,
                    Notes: model.devPrototype.Notes
                };

                //Get Non Seasonal Processes Data

                var getNSActualCompleteDate = "";

                model.cpDevPrototypeActualProcessesData = [];

                for (var i = 0; i < model.criticalPathDevPrototypeActualProcesses.length; i++) {
                    getNSActualCompleteDate = "";


                    if (model.criticalPathDevPrototypeActualProcesses[i].ActualCompleteDate) {
                        var nsActualCompleteDate = new Date(model.criticalPathDevPrototypeActualProcesses[i].ActualCompleteDate);

                        // After this construct a string with the above results as below
                        getNSActualCompleteDate = $filter('date')(nsActualCompleteDate, 'short');
                    }

                    model.cpDevPrototypeActualProcessesData.push({
                        CriticalPathDevPrototypeActualProcessId: model.criticalPathDevPrototypeActualProcesses[i].CriticalPathDevPrototypeActualProcessId,
                        CriticalPathDevPrototypeId: model.devPrototype.CriticalPathDevPrototypeId,
                        ProcessName: $filter('uppercase')(model.criticalPathDevPrototypeActualProcesses[i].ProcessName),
                        ProcessType: $filter('uppercase')(model.criticalPathDevPrototypeActualProcesses[i].ProcessType),
                        SortOrder: model.criticalPathDevPrototypeActualProcesses[i].SortOrder,
                        CanBeDeleted: model.criticalPathDevPrototypeActualProcesses[i].CanBeDeleted,
                        CanChangeName: model.criticalPathDevPrototypeActualProcesses[i].CanChangeName,
                        ActualCompleteDate: getNSActualCompleteDate,
                        IsDeleted: false,
                        Notes: model.criticalPathDevPrototypeActualProcesses[i].Notes
                    });
                }

                //Add Non Seasonal deleted rows to the list to delete from database
                for (var j = 0; j < model.cpDevPrototypeActualProcessesToDelete.length; j++) {
                    model.cpDevPrototypeActualProcessesData.push({
                        CriticalPathDevPrototypeActualProcessId: model.cpDevPrototypeActualProcessesToDelete[j].CriticalPathDevPrototypeActualProcessId,
                        CriticalPathDevPrototypeId: model.devPrototype.CriticalPathDevPrototypeId,
                        IsDeleted: true
                    });
                }

                //Get Seasonal Processes Data

                var getEstStartDate = "";
                var getTargetDate = "";
                var getRevStartDate = "";
                var getRevisedTargetDate = "";
                var getActualCompleteDate = "";

                //clear before looping
                model.cpDevPrototypeFinalProcessesData = [];

                if (model.criticalPathDevPrototypeFinalProcesses) {
                    for (var i = 0; i < model.criticalPathDevPrototypeFinalProcesses.length; i++) {
                        getEstStartDate = "";
                        getTargetDate = "";
                        getRevStartDate = "";
                        getRevisedTargetDate = "";
                        getActualCompleteDate = "";

                        //Format Est dates
                        if (model.criticalPathDevPrototypeFinalProcesses[i].EstStartDate) {
                            var estStartDate = new Date(model.criticalPathDevPrototypeFinalProcesses[i].EstStartDate);

                            // After this construct a string with the above results as below
                            getEstStartDate = $filter('date')(estStartDate, 'short');
                        }

                        if (model.criticalPathDevPrototypeFinalProcesses[i].TargetDate) {
                            var TargetDate = new Date(model.criticalPathDevPrototypeFinalProcesses[i].TargetDate);

                            // After this construct a string with the above results as below
                            getTargetDate = $filter('date')(TargetDate, 'short');
                        }

                        //Format Rev dates
                        if (model.criticalPathDevPrototypeFinalProcesses[i].RevStartDate) {
                            var revStartDate = new Date(model.criticalPathDevPrototypeFinalProcesses[i].RevStartDate);

                            // After this construct a string with the above results as below
                            getRevStartDate = $filter('date')(revStartDate, 'short');
                        }

                        if (model.criticalPathDevPrototypeFinalProcesses[i].RevisedTargetDate) {
                            var RevisedTargetDate = new Date(model.criticalPathDevPrototypeFinalProcesses[i].RevisedTargetDate);

                            // After this construct a string with the above results as below
                            getRevisedTargetDate = $filter('date')(RevisedTargetDate, 'short');
                        }

                        if (model.criticalPathDevPrototypeFinalProcesses[i].ActualCompleteDate) {
                            var actualCompleteDate = new Date(model.criticalPathDevPrototypeFinalProcesses[i].ActualCompleteDate);

                            // After this construct a string with the above results as below
                            getActualCompleteDate = $filter('date')(actualCompleteDate, 'short');
                        }

                        model.cpDevPrototypeFinalProcessesData.push({
                            CriticalPathDevPrototypeFinalProcessId: model.criticalPathDevPrototypeFinalProcesses[i].CriticalPathDevPrototypeFinalProcessId,
                            CriticalPathDevPrototypeId: model.devPrototype.CriticalPathDevPrototypeId,
                            ProcessName: $filter('uppercase')(model.criticalPathDevPrototypeFinalProcesses[i].ProcessName),
                            ProcessType: $filter('uppercase')(model.criticalPathDevPrototypeFinalProcesses[i].ProcessType),
                            SortOrder: model.criticalPathDevPrototypeFinalProcesses[i].SortOrder,
                            CanBeDeleted: model.criticalPathDevPrototypeFinalProcesses[i].CanBeDeleted,
                            CanChangeName: model.criticalPathDevPrototypeFinalProcesses[i].CanChangeName,
                            OverrideRevisedTargetDate: model.criticalPathDevPrototypeFinalProcesses[i].OverrideRevisedTargetDate,
                            EstStartDate: getEstStartDate,
                            TargetDate: getTargetDate,
                            RevStartDate: getRevStartDate,
                            RevisedTargetDate: getRevisedTargetDate,
                            ActualCompleteDate: getActualCompleteDate,
                            CriticalPathProcessApprovedId: model.criticalPathDevPrototypeFinalProcesses[i].CriticalPathProcessApprovedId,
                            ApprovedBy: model.criticalPathDevPrototypeFinalProcesses[i].ApprovedBy,
                            ApprovalDate: $filter('date')(model.criticalPathDevPrototypeFinalProcesses[i].ApprovalDate, 'short'),
                            IsDeleted: false,
                            IsProcessLocked: model.criticalPathDevPrototypeFinalProcesses[i].IsProcessLocked,
                            Notes: model.criticalPathDevPrototypeFinalProcesses[i].Notes
                        });
                    }
                }

                //Add Seasonal deleted rows to the list to delete from database
                for (var j = 0; j < model.cpDevPrototypeFinalProcessesToDelete.length; j++) {
                    model.cpDevPrototypeFinalProcessesData.push({
                        CriticalPathDevPrototypeFinalProcessId: model.cpDevPrototypeFinalProcessesToDelete[j].CriticalPathDevPrototypeFinalProcessId,
                        CriticalPathDevPrototypeId: model.devPrototype.CriticalPathDevPrototypeId,
                        IsDeleted: true
                    });
                }

                //Get Stocknumbers data model.stockNumbersData
                if (model.stockNumbersData.length > 0) {
                    model.prototypeStockNumbersData = [];
                    for (var s = 0; s < model.stockNumbersData.length; s++) {
                        var isDefault = model.devPrototype.PrototypeSeasonalId === model.stockNumbersData[s].PrototypeSeasonalId;

                        model.prototypeStockNumbersData.push({
                            PrototypeSeasonalId: model.stockNumbersData[s].PrototypeSeasonalId,
                            CriticalPathDevPrototypeId: model.stockNumbersData[s].CriticalPathDevPrototypeId,
                            IsLeatherApproved: model.stockNumbersData[s].IsLeatherApproved,
                            IsConfirmationSampleApproved: model.stockNumbersData[s].IsConfirmationSampleApproved,
                            IsFinalSpecApprLocked: model.stockNumbersData[s].IsFinalSpecApprLocked,
                            IsFinalCostConfCBDLoaded: model.stockNumbersData[s].IsFinalCostConfCBDLoaded,
                            IsThreeOneTestComplete: model.stockNumbersData[s].IsThreeOneTestComplete,
                            IsRSTestComplete: model.stockNumbersData[s].IsRSTestComplete,
                            IsMatlRefFolderSigned: model.stockNumbersData[s].IsMatlRefFolderSigned,
                            IsModelSizeApproved: model.stockNumbersData[s].IsModelSizeApproved,
                            IsConfSampleSent: model.stockNumbersData[s].IsConfSampleSent,
                            IsDefault: isDefault
                        });
                    }
                }

                CriticalPathService.updateCriticalPathDevPrototype(model.criticalPathDevPrototypeData, model.cpDevPrototypeActualProcessesData, model.cpDevPrototypeFinalProcessesData, model.prototypeStockNumbersData)
                    .then(function (response) {
                        if (response.IsSuccessful) {
                            toaster.pop({ type: 'success', title: 'Success!', body: 'Record Saved Successfully.', timeout: 5000 });

                            $scope.IsFinalSpecAltered = false;
                            model.getDevPrototypeWithProcesses();
                        }
                        else {
                            if (response.Result === 1)
                                toaster.pop({ type: 'error', title: 'Error!', body: 'The critical path you are updating does not exist. Please contact your system administrator', timeout: 5000 });
                            else
                                toaster.pop({ type: 'error', title: 'Error!', body: 'There was an error while saving the record. Please contact your system administrator', timeout: 5000 });
                        }
                    }, function () {
                        toaster.pop({ type: 'error', title: 'Error!', body: 'There was an error while saving the record. Please contact your system administrator', timeout: 5000 });
                    });

            }
            else {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'Please review all fields indicated in red',
                    timeout: 5000
                });
            }
        };

        model.Report = function () {
            $scope.criticalPathDevPrototypeEditForm.$setPristine();

            var params = '{"CriticalPathDevPrototypeId":"' + model.devPrototype.CriticalPathDevPrototypeId + '","ProtoSeasonalId":"' + model.devPrototype.PrototypeSeasonalId + '"}';

            var reportName = 'DevProtoCriticalPath';

            ReportService.generateReportMultiParam(reportName, params).then(function (response) {
                var file = new Blob([response], { type: 'application/pdf' });
                saveAs(file, reportName + '.pdf');

            }, function () {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'There was an error generating the report. Please contact your system administrator.',
                    timeout: 5000
                });

            });
        };

        model.Search = function () {
            $state.go("criticalPathIndex", { searchType: 2 });
        };

        $scope.replaceLineBreaks = function (v) {
            if (v) {
                var newValue = v.replace(/[\r\n]+/g, '\xa0\xa0');
                return newValue;
            }
        };

        //model.init();
    }
})();
